// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"toggle-switch_toggleSwitch__yz4DO","track":"toggle-switch_track__N9mvT","handle":"toggle-switch_handle__0eV8A","active":"toggle-switch_active__0dxYq"};